import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export interface IExcludeScheduleLocation {
  scheduleId: number;
  locationCode: string;
  narrative: string;
}

export const useExcluseScheduleLocation = () => {
  return useMutation({
    mutationFn: excludeScheduleLocation,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.getCalendarEvents.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.getCalendarSidebarDetails.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.scheduleOverview.invalidateAll());
      queryClient.invalidateQueries(queryKeys.scheduleList.invalidateAll());
      queryClient.invalidateQueries(queryKeys.schedules.invalidateAll());
    },
  });
};

async function excludeScheduleLocation(payload: IExcludeScheduleLocation) {
  const response = await requestCCApi({
    url: '/scheduleLocationExclusions',
    method: 'POST',
    data: payload,
  });

  return response;
}
